import React from 'react';
import { formatDate, formatTime } from '../../utils/formatUtils';

/**
 * Composant pour afficher le contenu d'impression des examens
 */
const PrintContent = ({ examen, sessions, nombreSessions }) => (
  <div className="hidden print:block">
    <table className="w-full border-collapse mb-4">
      <thead>
        <tr className="bg-gray-100">
          <th className="border border-gray-300 px-2 py-1 font-semibold">Classe</th>
          <th className="border border-gray-300 px-2 py-1 font-semibold">Période</th>
          <th className="border border-gray-300 px-2 py-1 font-semibold">Statut</th>
          <th className="border border-gray-300 px-2 py-1 font-semibold">Sessions</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-gray-300 px-2 py-1">
            {examen?.classe?.libelle || 'Non spécifiée'}
          </td>
          <td className="border border-gray-300 px-2 py-1">
            {formatDate(examen?.date_debut) || ''} - {formatDate(examen?.date_fin) || ''}
          </td>
          <td className="border border-gray-300 px-2 py-1">{examen?.status || 'PROGRAMME'}</td>
          <td className="border border-gray-300 px-2 py-1">{nombreSessions || 3}</td>
        </tr>
      </tbody>
    </table>

    {examen?.description && (
      <div className="bg-gray-50 p-2 border border-gray-200 mb-4">
        <h3 className="font-semibold text-sm mb-1">Description</h3>
        <p className="text-sm">{examen.description}</p>
      </div>
    )}
    
    {/* Liste des sessions pour l'impression */}
    <div className="print-no-break">
      <h3 className="font-bold text-base mb-2 border-b border-gray-300 pb-1">PROGRAMME DES SESSIONS</h3>
      <table className="w-full border-collapse mb-4">
        <thead className="bg-gray-100">
          <tr>
            <th className="border border-gray-300 px-2 py-1 text-center w-8">N°</th>
            <th className="border border-gray-300 px-2 py-1">Module</th>
            <th className="border border-gray-300 px-2 py-1 text-center">Date</th>
            <th className="border border-gray-300 px-2 py-1 text-center">Horaire</th>
            <th className="border border-gray-300 px-2 py-1 text-center">Salle</th>
            <th className="border border-gray-300 px-2 py-1 text-center">Surveillant</th>
          </tr>
        </thead>
        <tbody>
          {sessions && sessions.length > 0 ? (
            sessions.map((session, index) => (
              <tr key={session.id || index}>
                <td className="border border-gray-300 px-2 py-1 text-center font-semibold">{index + 1}</td>
                <td className="border border-gray-300 px-2 py-1">
                  {session.module?.libelle || (session.module?.module?.libelle) || 'Non défini'}
                </td>
                <td className="border border-gray-300 px-2 py-1 text-center">
                  {formatDate(session.date_examen)}
                </td>
                <td className="border border-gray-300 px-2 py-1 text-center">
                  {formatTime(session.heure_debut)} - {formatTime(session.heure_fin)}
                </td>
                <td className="border border-gray-300 px-2 py-1 text-center">
                  {session.salle?.libelle || 'Non définie'}
                </td>
                <td className="border border-gray-300 px-2 py-1 text-center">
                  {session.surveillant_principal ? (
                    `${session.surveillant_principal.first_name || ''} ${session.surveillant_principal.last_name || ''}`
                  ) : (
                    'Non assigné'
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="border border-gray-300 px-2 py-3 text-center">
                Aucune session programmée
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    {/* Consignes/instructions */}
    <div className="border border-gray-300 border-dashed p-2 bg-gray-50 my-4">
      <p className="text-sm italic">
        Les étudiants doivent se présenter 15 minutes avant le début de chaque épreuve, munis de leur carte d'étudiant.
        <br />Tout retard de plus de 30 minutes entrainera le refus d'accès à la salle d'examen.
      </p>
    </div>
    
    {/* Pied de page */}
    <div className="text-center text-xs text-gray-500 mt-6 print-footer">
      <p>Document généré le {new Date().toLocaleDateString('fr-FR')} à {new Date().toLocaleTimeString('fr-FR')}</p>
    </div>
  </div>
);

export default PrintContent; 